<div class="popup_header">
    <strong class="popup_title">{{popupTitle}} <span class="template_url">user-confirm-dialog</span></strong>
    <button type="button" class="popup_close" (click)="popupClose()"><span class="blind">팝업 닫기</span></button>
</div>
<div class="popup_content" *ngIf="status == 'ON'">
    <strong class="desc_center">선택한 ID의 가입을 승인하시겠습니까?</strong>
    <dl class="info_box">
        <div class="dis_flex">
            <dt>아이디</dt>
            <dd>{{user.userId}}</dd>
        </div>
        <div class="dis_flex">
            <dt>가입일</dt>
            <dd>{{user.regDate | date: 'yyyy년 MM월 dd일'}}</dd>
        </div>
        <div class="dis_flex">
            <dt>등급</dt>
            <dd>
                <div class="select">
                    <select class="select_current" [(ngModel)]="user.userGrade">
                        <option value="">선택하세요</option>
                        <option value="G1">이웃등급</option>
                        <option value="G2">파워등급</option>
                    </select>
                </div>
            </dd>
        </div>
    </dl>
</div>
<div class="popup_content" *ngIf="status == 'changeGrade'">
    <strong class="desc_center">회원등급을 변경하시겠습니까?</strong>
    <dl class="info_box">
        <div class="dis_flex">
            <dt>아이디</dt>
            <dd>{{user.userId}}</dd>
        </div>
        <div class="dis_flex">
            <dt>가입일</dt>
            <dd>{{user.regDate | date: 'yyyy년 MM월 dd일'}}</dd>
        </div>
        <div class="dis_flex">
            <dt>등급</dt>
            <dd>
                <div class="select">
                    <select class="select_current" [(ngModel)]="userGrade">
                        <option value="G1">이웃등급</option>
                        <option value="G2">파워등급</option>
                    </select>
                </div>
            </dd>
        </div>
    </dl>
</div>
<div class="popup_content" *ngIf="status == 'userClass'">
    <strong class="desc_center">회원분류를 지정하시겠습니까?</strong>
    <dl class="info_box">
        <div class="dis_flex">
            <dt>아이디</dt>
            <dd>{{user.userId}}</dd>
        </div>
        <div class="dis_flex">
            <dt>가입일</dt>
            <dd>{{user.regDate | date: 'yyyy년 MM월 dd일'}}</dd>
        </div>
        <div class="dis_flex">
            <dt>분류</dt>
            <dd>
                <div class="select">
                    <select class="select_current" [(ngModel)]="userClass">
                        <option value="">::선택하세요::</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                        <option value="D">D</option>
                        <option value="E">E</option>
                        <option value="F">F</option>
                    </select>
                </div>
            </dd>
        </div>
    </dl>
</div>
<div class="popup_content" *ngIf="status == 'RR'">
    <strong class="desc_center">승인사유를 입력해 주세요.</strong>
    <div class="popup_box_gray"><b class="txt_gray mr-6">ID : {{user.userId}}</b></div>
    <div class="textarea mt-12"><textarea [(ngModel)]="comment" placeholder="승인사유를 입력해 주세요."></textarea></div>
</div>
<div class="popup_content" *ngIf="status == 'RJ' && user.status == 'RD'">
    <strong class="desc_center">반려사유를 입력해 주세요.</strong>
    <div class="popup_box_gray"><b class="txt_gray mr-6">ID : {{user.userId}}</b></div>
    <div class="textarea mt-12"><textarea [(ngModel)]="comment" placeholder="반려사유를 입력해 주세요."></textarea></div>
</div>
<div class="popup_content" *ngIf="status == 'RJ' && user.status == 'RJ'">
    <div class="popup_box_gray"><b class="txt_gray mr-6">ID : {{user.userId}}</b></div>
    <div class="textarea mt-12"><textarea [(ngModel)]="comment" [disabled]="true"></textarea></div>
</div>
<div class="popup_content" *ngIf="status == 'RD' && user.status == 'RD'">
    <div class="popup_box_gray"><b class="txt_gray mr-6">ID : {{user.userId}}</b></div>
    <div class="textarea mt-12"><textarea [(ngModel)]="comment" [disabled]="true"></textarea></div>
</div>
<div class="popup_footer" *ngIf="user.status == 'RD' || status == 'RR' || status == 'changeGrade' || status == 'userClass'">
    <button type="button" class="btn_item btn-default" (click)="popupClose()">취소</button>
    <button type="button" *ngIf="buttonTitle" class="btn_item btn-primary" (click)="proc()">{{buttonTitle}}</button><!-- 개발요청::회원등급변경 시 "저장" -->
</div>
<div class="popup_footer" *ngIf="status != 'RR' && user.status == 'RJ' && status != 'changeGrade'">
    <button type="button" class="btn_item btn-default" (click)="popupClose()">확인</button>
</div>
